if (import.meta.hot) {
	import.meta.hot.accept();
}

import { loadApp, loadModule } from '@spon/core';
import 'lazysizes';

import Header from '@/globals/Header';
import SetVh from '@/globals/SetVh';

import '@/plugins/logger';
import webfontloader from '@/plugins/webfontloader';
import detectTab from '@/utils/detectTab';
import activeLinks from '@/utils/activeLinks';
import localLinks from '@/utils/localLinks';

webfontloader();

// load from data-behaviours
const app = loadApp(name => import(`./behaviours/${name}.js`), document.body); // eslint-disable-line

loadModule({
	module: Header,
	id: 'header',
	node: document.getElementById('header'),
	keepAlive: false,
});

loadModule({
	module: SetVh,
	id: 'set-vh',
	node: document.body,
	keepAlive: false,
});

detectTab();
activeLinks(window.location.pathname);
localLinks();

// https://htmx.org/events
if (typeof htmx !== 'undefined') {
	htmx.on('htmx:beforeSwap', ({ target }) => {
		localLinks(target);
	});

	htmx.on('htmx:afterSwap', ({ target }) => {
		loadApp(name => import(`./behaviours/${name}.js`), target); // eslint-disable-line
	});
}
